/**
 * Reusable component for a password field—the value add here is built-in see/hide
 * password control.
 */
import React, { useState } from 'react'

import makeStyles from '@mui/styles/makeStyles'

import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'

import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

import BrandIconButton from './brand/BrandIconButton'

const useStyles = makeStyles(
  theme => ({
    input: {
      '&:-webkit-autofill': {
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0
      }
    },

    positionEnd: {
      margin: theme.spacing(0.5)
    }
  }),
  {
    name: 'PasswordField'
  }
)

const PasswordField = props => {
  const [showPassword, setShowPassword] = useState(false)

  const handleToggleShowPassword = event => setShowPassword(showPassword => !showPassword)
  const handleMouseDownShowPassword = event => event.preventDefault()
  // ^^^^^ Not sure what this does but Material UI had it so to play it safe we put it here too.

  const classes = useStyles() // No override because we’re actually using these for the input and input adornment.
  return (
    <TextField
      variant="standard"
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        classes: { input: classes.input },
        endAdornment: (
          <InputAdornment classes={{ positionEnd: classes.positionEnd }} position="end">
            <BrandIconButton
              aria-label="toggle password visibility"
              onClick={handleToggleShowPassword}
              onMouseDown={handleMouseDownShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </BrandIconButton>
          </InputAdornment>
        )
      }}
      {...props}
    />
  )
}

PasswordField.propTypes = {
  // ...same props as Material UI TextField.
}

export default PasswordField
